import React, { useEffect, useMemo, useState } from 'react'
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import moment from "moment";
import { CMSPath } from '../../../config/constant';
import BookingOverviewPage from './BookingOverviewPage';
import { cancelWayBooking, updateMyWayBooking } from '../../../action/wayActivities';
import { closeOrderPopUp } from '../../action/hCommerce2';
import { formatTime } from '../spaBookingV2/spaBooking2a';
import { toBool } from '../../JS/utility';


const WayActivitity1 = (props) => {
  const {fetchBookings, setLoaderDetails, t} = props;
  const [bookingOverviewDetails, setBookingOverviewDetails] = useState(null);
  const imageUrl = useMemo(()=> t('way_activity.booking_page_hero_img_url'),[t])

  const formatDate = (dateString) => {
    console.log(dateString, "dateString");
 
    return `${moment(dateString).format(props.dateFormat.toUpperCase())}`

  };

  const groupingByDate = (data) => {
    console.log("inside, grouping by date", data)
    const groupedAccToDay = new Map();

    data.sort((a, b) => {
      return (
        new Date(a.event.startDateTime.split("T")[0]).getTime() -
        new Date(b.event.startDateTime.split("T")[0]).getTime()
      );
    });
    
    console.log(data);

    data.forEach((d) => {
      const groupingKey = formatDate(d.event.startDateTime.split("T")[0]);
      if (groupedAccToDay.has(groupingKey)) {
        const keyData = groupedAccToDay.get(groupingKey);
        keyData.push(d);
      } else {
        groupedAccToDay.set(groupingKey, [d]);
      }
    });

    console.log(groupedAccToDay, "groupedAccToDay");
    return groupedAccToDay;
  };

  const onEditBookingAttempted =()=>{
    setBookingOverviewDetails(null);
    fetchBookings();
  }

  const handleUpdateBooking = async( payload )=>{
      
    setLoaderDetails({show:true, displayMsg: t("way_activity.loaders.updating_booking")});
    try {
     
      await updateMyWayBooking(payload)
      .then(data=>{
        props.closeOrderPopUp(true, t("way_activity.my_bookings_page.booking_updated_success"), "");
      })
      .catch((errMessage)=>{
        // props.setSuccessFailPop(true, false, errMessage.message);
        props.closeOrderPopUp(true, errMessage.message, "", true);

      })
      .finally(()=>{
        setLoaderDetails({show:false });
        onEditBookingAttempted()
      })
     
    } catch (err) {
      console.error("...", err);
    }

  }

  const handleCancelBooking = async (data) => {
  
    setLoaderDetails({show:true, displayMsg: t("way_activity.loaders.cancelling_booking")});

    const payload = {
      bookingId: data.id
    }

    try {
     
      await cancelWayBooking(payload)
      .then(data=>{
        props.closeOrderPopUp(true, t("way_activity.my_bookings_page.booking_cancelled_success"), "");
      })
      .catch((errMessage)=>{
        // props.setSuccessFailPop(true, false, errMessage.message);
        props.closeOrderPopUp(true, errMessage.message, "", true);

      })
      .finally(()=>{
        setLoaderDetails({show:false });
        onEditBookingAttempted()
      })
     
    } catch (err) {
      console.error("...", err);
    }
  };

  useEffect(()=>{
    fetchBookings();
  },[])

  return (
    <>
     <header className="inner-pages w-footer subpages">
                       { <a className="button-back" onClick={ ()=>{  
                        if(bookingOverviewDetails) setBookingOverviewDetails(null);
                        else props.goPreviousPage(); }
                      }></a>}
                        <div className="heading align-center">
                        <div class="header">
                            <p className="text">{t("way_activity.common.header_text")}</p>
                            {/* <img src={`${CMSPath}${props.logo}`} alt="" /> */}
                        </div>
                        </div>
    </header>
    { bookingOverviewDetails ? <BookingOverviewPage bookingOverviewDetails={bookingOverviewDetails} handleCancelBooking={handleCancelBooking} handleUpdateBooking ={handleUpdateBooking} setLoaderDetails={setLoaderDetails}/>
    : <section id="activitiespage1" className="widgets padding-0 margin-0 container-bg">
      <section class="widgets activity-listing activity-details">
        {
          <>
            <div class="">

              <div class="widget-header-img">
                <img
                  src={`${imageUrl}`}
                  alt={`Booking page hero image`}
                />
              </div>

              <div class="widget-header-title">{t("way_activity.my_bookings_page.hero_title")}</div>
              <div class="widget-header-subtitle">
              {t("way_activity.my_bookings_page.hero_subtitle")}
              </div>
              <div class="widget-header-desc">
              {t("way_activity.my_bookings_page.hero_description")}
              </div>
            </div>

          </>
        }
      </section>
      <section className="booking-listing">
        <div className="section-title-1">
          <div className="text-bold">{t("way_activity.my_bookings_page.my_bookings_heading")}</div>
        </div>
        {
        props.myBookings ?
        ( props.myBookings.length > 0 ?
          ( Array.from(
              groupingByDate(props.myBookings).entries()
            ).map(([day, dataOnThatDay]) => {
              return (
                <div class="list-items-container">
                  <div class="list-item-heading">{day}</div>
                  {dataOnThatDay.map((booking, index) => {
                    return (<>
                     <div key={index } className="date-group">

                      {/* <div className="date-label">{booking.experienceDate}</div> */}
                      <div className="booking-row">
                        <div className="dot"> <DotSvg /></div>
                        <div className="booking-main">
                          <div className="title text-bold">{booking.experience.title}</div>
                          <div className="time">{ booking.event && booking.event.startDateTime && booking.event.startDateTime.split("T")[1] && formatTime(booking.event.startDateTime.split("T")[1],toBool(props.timeFormat))}</div>
                          
                        </div>
                        <div className="row-end">
                          {booking.status === "confirmed" ? (
                            <div className="edit-icon"
                              onClick={()=>setBookingOverviewDetails(booking)}
                            ><EditSvg /></div>
                          ) : null}

                          {booking.status === "cancelled"  && <div className='cancelled-booking-text'>{t("way_activity.my_bookings_page.cancelled_label")}</div>}
                        </div>
                      </div>
                      </div>

                    </>)
                    })
                  }

                </div>
         
                )}))
          : 
          <div>{t("way_activity.my_bookings_page.no_reservation")}</div>

          )

        :
        <div>{t("way_activity.my_bookings_page.observed_issue")}</div>
        
        }





        <div class="row">
              <div class="form-controls">
                <button class="book_an_activity" onClick={props.goNextPage}>
                {t("way_activity.my_bookings_page.view_all_button").toUpperCase()}
                </button>
              </div>
            </div>
      </section>
      </section>

    }
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    currentWidgets: state.store.sideNavBar.currentWidget,
    dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
      : "",
    // timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
    serverTimeDate: state.store.home.serverTimeDate.date,
    serverDate: state.store.home.serverTimeDate,
    timeFormat:
    state.store.home.clientConfig.extraConfigParam &&
    state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,


  };
};

export default connect(mapStateToProps, {closeOrderPopUp})(
  withTranslation("translations")(WayActivitity1)
);


const DotSvg = ()=>{
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
  <circle cx="12" cy="12.5862" r="12" fill="#DDACB5"/>
  </svg>
}

const EditSvg = () =>{
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
          <path d="M19.6071 19.3322C19.6071 20.2132 18.8911 20.9562 18.0101 20.9562H5.23109C4.35009 20.9562 3.63409 20.2132 3.63409 19.3322V6.55321C3.63409 5.67221 4.35009 4.98221 5.23109 4.98221H12.6851V3.91821H5.23109C3.76309 3.91821 2.56909 5.08621 2.56909 6.55421V19.3322C2.56909 20.8002 3.76309 22.0202 5.23109 22.0202H18.0091C19.4771 22.0202 20.6711 20.7992 20.6711 19.3322V11.9042H19.6061L19.6071 19.3322Z" fill="#231F20"/>
          <path d="M20.8071 3.75622C20.0031 2.95122 18.6001 2.95122 17.7951 3.75622L10.6521 10.8992C10.5841 10.9672 10.5351 11.0532 10.5121 11.1462L9.76012 14.1572C9.71512 14.3382 9.76812 14.5302 9.90012 14.6632C10.0011 14.7642 10.1371 14.8192 10.2761 14.8192C10.3191 14.8192 10.3621 14.8142 10.4051 14.8032L13.4171 14.0502C13.5111 14.0272 13.5961 13.9782 13.6641 13.9102L20.8071 6.76722C21.2091 6.36522 21.4311 5.83022 21.4311 5.26122C21.4311 4.69222 21.2101 4.15822 20.8071 3.75622ZM13.0161 13.0532L11.0081 13.5552L11.5101 11.5472L17.4191 5.63822L18.9251 7.14422L13.0161 13.0532ZM20.0541 6.01422L19.6781 6.39022L18.1721 4.88422L18.5481 4.50822C18.9501 4.10622 19.6521 4.10622 20.0541 4.50822C20.2551 4.70922 20.3661 4.97622 20.3661 5.26122C20.3661 5.54622 20.2551 5.81322 20.0541 6.01422Z" fill="#231F20"/>
        </svg>
}